// Modules
import React from "react";
import PropTypes from "prop-types";

const LinkedIn = (props) => {
	const {
		clssName,
		color,
	} = props;

	return (
		<svg
			width="30"
			height="30"
			viewBox="0 0 30 30"
			xmlns="http://www.w3.org/2000/svg"
			className={clssName}
		>
			<g clipPath="url(#clip0)">
				<path
					d="M29.9924 30.0002V29.999H30V18.9963C30 13.6139 28.841 9.46777 22.5486 9.46777C19.5234 9.46777 17.4937 11.1277 16.6646 12.7016H16.5773V9.97051H10.6113V29.999H16.824V20.0814C16.824 17.4699 17.3191 14.9451 20.5529 14.9451C23.7393 14.9451 23.7867 17.9252 23.7867 20.249V30.0002H29.9924Z"
					fill={color}
				/>
				<path
					d="M0.495117 9.97168H6.71484V30.0002H0.495117V9.97168Z"
					fill={color}
				/>
				<path
					d="M3.60234 0C1.61367 0 0 1.61367 0 3.60234C0 5.59102 1.61367 7.23867 3.60234 7.23867C5.59102 7.23867 7.20469 5.59102 7.20469 3.60234C7.20352 1.61367 5.58984 0 3.60234 0Z"
					fill={color}
				/>
			</g>
			<defs>
				<clipPath>
					<rect
						width="30"
						height="30"
						fill="white"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

LinkedIn.propTypes = {
	clssName: PropTypes.string,
	color: PropTypes.string,
};

LinkedIn.defaultProps = {
	clssName: "",
	color: "#EEDFD2",
};

export default LinkedIn;
